import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class WeightService extends BaseService {

    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/peso', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get('/peso/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(model) {
        return new Promise((resolve, reject) => {
            axios.post('/peso', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    update(model, id) {
        return new Promise((resolve, reject) => {
            axios.put('/peso/' + id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/peso/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/weight.js